var staticDayTime = 86400000

module.exports = staticDayTime



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticDayTime.js
// module id = 62
// module chunks = 98